import { useContext } from 'react';
import './PageRadioFO.css';
import { SlidesContext } from '../../contexts/SlidesContext';
import ReviewFormattedMessage from '../../generics/ReviewFormattedMessage';

export default function PageRadioFO({ slide }) {
    const { slidesAnswers, updateValues } = useContext(SlidesContext);
    const s = slide; // slide is now the current slide object
    


    // Guard: only render if inputsCB exists and has at least one item
    if (!s.inputsCB || !Array.isArray(s.inputsCB) || !s.inputsCB[0]) {
        return null;
    }

    const inputKey = s.inputsCB[0].key;
    const value = slidesAnswers[s.inputNumber]?.[inputKey] || '';

    const handleChange = (e) => {
        updateValues(s.inputNumber, inputKey, e.target.value);
    };

    return (
        <div className="PageRadioFO animate__animated animate__fadeInRight">
            <div className="PageRadioFO-help">
                <ReviewFormattedMessage descriptor={s.aide} />
            </div>
            <div className="PageRadioFO-title">
                <div className="PageRadioFO-title-header">
                    <ReviewFormattedMessage descriptor={s.pageTitleType} />
                </div>
                <div className="PageRadioFO-question">
                    <ReviewFormattedMessage descriptor={s.pageTitleInfos && s.pageTitleInfos[0] && s.pageTitleInfos[0].info} />
                </div>
            </div>
            <div className="PageRadioButton-radioButtonList">
                <div className="RadioButton">
                    <div className="RadioButton-wrap">
                        <input
                            className="RadioButton-hidden RadioButton-radio-label RadioButton-choice-button"
                            type="radio"
                            name={inputKey}
                            value="FAIT"
                            id={inputKey + '-FAIT'}
                            checked={value === 'FAIT'}
                            onChange={handleChange}
                        />
                        <label className="RadioButton-button-label" htmlFor={inputKey + '-FAIT'}>
                            <h1><ReviewFormattedMessage descriptor={s.leftLabel} /></h1>
                        </label>
                    </div>
                </div>
                <div className="RadioButton">
                    <div className="RadioButton-wrap">
                        <input
                            className="RadioButton-hidden RadioButton-radio-label RadioButton-choice-button"
                            type="radio"
                            name={inputKey}
                            value="OPINION"
                            id={inputKey + '-OPINION'}
                            checked={value === 'OPINION'}
                            onChange={handleChange}
                        />
                        <label className="RadioButton-button-label" htmlFor={inputKey + '-OPINION'}>
                            <h1><ReviewFormattedMessage descriptor={s.rightLabel} /></h1>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
}
